import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import MarkdownIt from 'markdown-it';
import { markdownItTable } from 'markdown-it-table';
import { MarkdownTransformer } from '@atlaskit/editor-markdown-transformer';
import { MarkdownParser } from '@atlaskit/editor-prosemirror/markdown';
import { Node } from '@atlaskit/editor-prosemirror/model';
import { fg } from '@atlaskit/platform-feature-flags';
import mdPluginCitation from '../md-plugin-citation';
import mdPluginDataSculptor from '../md-plugin-data-sculptor';
import { createLinkifyPlugin } from '../md-plugin-linkify';
import mdPluginMedia from '../md-plugin-media';
import mdPluginMentions from '../md-plugin-mention';
import { createSmartLinksPlugin } from '../md-plugin-smartlink';
import mdPluginTableBreakTags from '../md-plugin-table-break-tags';
import { mdToPmSchema } from './mappings';
import { enableSchemaPlugins, filterSchemaMapping } from './utils';
export var AiMateMarkdownTransformer = /*#__PURE__*/function (_MarkdownTransformer) {
  function AiMateMarkdownTransformer(schema, pluginConfig, streaming) {
    var _this;
    _classCallCheck(this, AiMateMarkdownTransformer);
    _this = _callSuper(this, AiMateMarkdownTransformer);
    var md = MarkdownIt('zero', {
      html: false
    });
    md.enable([
    // Process html entity - &#123;, &#xAF;, &quot;, ...
    'entity',
    // Process escaped chars and hardbreaks
    'escape', 'newline']);
    enableSchemaPlugins(md, schema);

    // enable modified version of linkify plugin
    // @see https://product-fabric.atlassian.net/browse/ED-3097
    md.use(createLinkifyPlugin(pluginConfig.linkify));
    md.use(mdPluginCitation);
    if (fg('rovo_enable_data_sculptor')) {
      md.use(mdPluginDataSculptor);
    }

    // Convert links with Linking Platform supported URLs to Smart Links
    if (!streaming && (schema.nodes.inlineCard || schema.nodes.blockCard || schema.nodes.embedCard)) {
      md.use(createSmartLinksPlugin(pluginConfig.smartLinks));
    }

    // Convert links matching people directory URLs to mentions
    if (schema.nodes.mention) {
      md.use(mdPluginMentions);
    }

    // Table support
    if (schema.nodes.table) {
      md.use(markdownItTable);
      if (fg('rovo_chat_enable_markdown_table_break_tags')) {
        md.use(mdPluginTableBreakTags);
      }
    }

    // Image support
    if (schema.nodes.media && schema.nodes.mediaSingle) {
      md.use(mdPluginMedia);
    }
    var filter = filterSchemaMapping(schema, mdToPmSchema);
    _this.parser = new MarkdownParser(schema, md, filter);
    return _this;
  }
  _inherits(AiMateMarkdownTransformer, _MarkdownTransformer);
  return _createClass(AiMateMarkdownTransformer, [{
    key: "parse",
    value: function parse(content) {
      var node = this.parser.parse(content);
      if (!node) {
        return new Node();
      }
      return node;
    }
  }]);
}(MarkdownTransformer);